<template>
	<div :class="parent_class">
    <template v-if="isVisible">
      <div :class="child_class" v-for="(product, index) in data" :key="index">
        <menuItem :data="product" :index="index" :design_type="design_type" :btn_design_type="btn_design_type" />
      </div>
    </template>
    <div v-else class="w-100" ref="placeholder">

    </div>
	</div>
</template>
<script>
	import menuItem from '@/components/restaurant-v2/menuItem'
	export default{
		components:{
			menuItem
		},
		props:{
			data:{
				type:Array,
				default: () => []
			},
			design_type:{
				type:String,
				default: '0'
			},
			btn_design_type:{
				type: String,
				default: '1'
			}
		},
    data(){
      return{
        isVisible: false,
      }
    },
		computed:{
			parent_class(){
				return this.design_type == 3 ? 'row no-gutters' : ''
			},
			child_class(){
				if(this.design_type == 3){
					return 'col-6 my-2 menu-3'
				}else if(this.design_type == 4){
					return 'row no-gutters bold-shadow-2 mb-4 rounded-6 pt-3 pb-2 px-2 border'
				}else{
					return 'w-100'
				}
			}
		},
    mounted(){
      this.createObserver();
    },
    methods:{
      createObserver() {
        const self = this
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              self.isVisible = true; // Set the image to be visible
              observer.unobserve(entry.target); // Stop observing
            }
          });
        });
        observer.observe(self.$refs.placeholder)
      },
    }
	}
</script>


// WEBPACK FOOTER //
// src/components/restaurant-v2/menuList.vue